import Admin from './admin'
import Alarms from './alarms'
import AlarmTypes from "./alarmTypes"
import Auth from "./auth"
import Common from './common'
import Customer from './customer'
import Device from './device'
import Fcp from './fcp'
import History from './history'
import Maps from './maps'
import MetricsDB from './metricsDB'
import Prefs from './prefs'
import Radio from './radio'
import Sets from './sets'
import SysDb from './systemDb'
import SysPerf from './sysPerf'
import Tower from './tower'
import Tasks from './tasks'
import Groups from './groups'
import MetryTable from "./metryTable"
import GlobalMgmt from "./globalMgmt"

export default Object.assign({},
    Admin,
    Alarms,
    AlarmTypes,
    Auth,
    Common,
    Customer,
    Device,
    Fcp,
    GlobalMgmt,
    History,
    Maps,
    MetricsDB,
    MetryTable,
    Prefs,
    Radio,
    Sets,
    SysDb,
    SysPerf,
    Tower,
    Tasks,
    Groups
)
